/**
 * Prefix with CRA PUBLIC_URL so routes and links work under a subpath deploy.
 */
export function appPath(path) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!base) return p;
  return `${base}${p}`;
}

/**
 * Path segment(s) for <Route path={...}> when using <BrowserRouter basename={PUBLIC_URL}>.
 * Link/navigate targets should still use {@link appPath}.
 */
export function routePathStripPublicUrl(absoluteOrAppPath) {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  let p = absoluteOrAppPath.startsWith('/') ? absoluteOrAppPath : `/${absoluteOrAppPath}`;
  if (base && p.startsWith(base)) {
    p = p.slice(base.length);
  }
  if (!p || p === '/') return '';
  return p.replace(/^\//, '');
}
